import { render, staticRenderFns } from "./rekonkr.vue?vue&type=template&id=09de0f36&scoped=true"
import script from "./rekonkr.vue?vue&type=script&lang=js"
export * from "./rekonkr.vue?vue&type=script&lang=js"
import style0 from "./rekonkr.vue?vue&type=style&index=0&id=09de0f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de0f36",
  null
  
)

export default component.exports